export const SET_ASIP_PROFILE = "asip_profile";
export const UPDATE_ASIP_PROFILE = "update_asip_profile";
export const CLEAR_ASIP_REDUCER = "clear_asip";
